import Content from "./Component/Content";

function Sidebar({ routes, onLinkClick, activePath }) {
  return (
    <div className="sidebar-content">
      <div className="sidebar">
        <Content
          routes={routes}
          onLinkClick={onLinkClick}
          activePath={activePath}
        />
      </div>
    </div>
  );
}

export default Sidebar;
